/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Brand_NameInputs */

const en_nav_brand_name = /** @type {(inputs: Nav_Brand_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening`)
};

const es_nav_brand_name = /** @type {(inputs: Nav_Brand_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening`)
};

/**
* | output |
* | --- |
* | "Listening" |
*
* @param {Nav_Brand_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_brand_name = /** @type {((inputs?: Nav_Brand_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Brand_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_brand_name(inputs)
	return en_nav_brand_name(inputs)
});